import React from 'react';
import ReactDOM from 'react-dom';
import Archives from './containers/Archives';
import reducers from './reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import './css/index.css';

const enhancers = compose( 
    applyMiddleware( ...[ ReduxThunk ]), window.devToolsExtension
    ? window.devToolsExtension()
    : f => f);

const store = createStore( reducers, enhancers );

ReactDOM.render(
    <Provider store={ store }>
        <Archives />
    </Provider>, document.getElementById('archives-app'));

